import React from 'react'

import { useSelector } from 'react-redux'
import { selectAccountConfig } from '@selectors'

import {
  COMMON_CONFIRM,
  COMMON_DENY,
  SAFEWALK_OFF_CAMPUS_TEXT,
  SAFEWALK_ON_CAMPUS_TEXT,
  SAFEWALK_ON_CAMPUS_QUESTION_TEXT
} from '@assets/i18n/strings'

import {
  Button,
  DARK_GREEN,
  GREEN,
  IconInline,
  Paragraph,
  ResponsiveContainer
} from '@omnilert/components'

import i18n from 'i18n-js'

import useStyles from './safewalk-setup.style'

const SafeWalkSetup = ({ onClickOnCampus, onClickOffCampus }) => {
  const classes = useStyles()

  const accountConfig = useSelector(selectAccountConfig)

  const { avatar } = { ...accountConfig }

  return (
    <ResponsiveContainer className={classes.responsive}>
      <IconInline
        className={classes.icon}
        name='clock'
        size={200}
      />
      <div className={classes.container}>
        <div className={classes.avatarContainer}>
          <img
            alt='avatar'
            className={classes.avatar}
            src={avatar}
          />
          <div className={classes.message}>
            <Paragraph size='md'>{i18n.t(SAFEWALK_ON_CAMPUS_QUESTION_TEXT)}</Paragraph>
          </div>
        </div>
        <Button
          backgroundColor={GREEN}
          className={classes.button}
          fullWidth
          hoverBackgroundColor={DARK_GREEN}
          id='isOnCampus'
          onClick={onClickOnCampus}
          size='lg'
          title={i18n.t(COMMON_CONFIRM)}
          titleClassName={classes.buttonTitle}
          variant='solid'
        />
        <Paragraph
          className={classes.text}
          color='var(--tips__text)'
          size='md'
        >
          {i18n.t(SAFEWALK_ON_CAMPUS_TEXT)}
        </Paragraph>
        <Button
          backgroundColor={GREEN}
          className={classes.button}
          fullWidth
          hoverBackgroundColor={DARK_GREEN}
          id='isOffCampus'
          onClick={onClickOffCampus}
          size='lg'
          title={i18n.t(COMMON_DENY)}
          titleClassName={classes.buttonTitle}
          variant='outlined'
        />
        <Paragraph
          className={classes.text}
          color='var(--tips__text)'
          size='md'
        >
          {i18n.t(SAFEWALK_OFF_CAMPUS_TEXT)}
        </Paragraph>
      </div>
    </ResponsiveContainer>
  )
}

export default SafeWalkSetup
